/**
 * Import Lib & assets
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

/**
 * styled components
 */

const Button = styled.a`
  ${t.mixins.flex()}
  padding: 13px 8px 13px 13px;
  margin-bottom: 4px;
  ${t.mixins.rem(14, 14)}
  font-family: ${t.font.primary};
  font-weight: ${t.font.bold};
  text-transform: uppercase;
  border-radius: 2px;
  background-color: ${t.color.tertiary};
  color: ${t.color.white};
  text-decoration: none;
  cursor: pointer;

  ${t.mixins.sm(`
    padding: 9px;
  `)}
`;
const Title = styled.span`
  ${t.mixins.sm(`
    ${t.mixins.rem(13, 13)}
    text-align: center;
  `)}
`;
const Arrow = styled.img.attrs({ src: t.image.arrow })`
  height: 29px;
  width: 29px;
  margin-left: 15px;

  ${t.mixins.sm(`
    display: none;
  `)}
`;

/**
 * external component is..
 */

const Button__external = ({ title, href }) => (
  <Button href={href} target="_blank">
    <Title>{title}</Title>
    <Arrow />
  </Button>
);

export default Button__external;

Button__external.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Button__external.defaultProps = {
  style: {},
};

/*
    import Button__external from 'components/button/external/button__external'
    <Button__external />
  */
